import { render } from "./SettingsMenu.vue?vue&type=template&id=5e1d461c&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"

import "./SettingsMenu.vue?vue&type=style&index=0&id=5e1d461c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1d461c"]])

export default __exports__